import api from '@/api';

export default {
    getFavorites(): Promise<ItemList<mail.Favorite>> {
        return api.get<ItemList<mail.Favorite>>({
            url: '/api/ews/favorite',
        })
        .then((items) => {
            return (
              items
                // 삼호에서는 범주는 제외하고 폴더만 가져옴
                .filter((x) => x.type === 'Folder')
            )
          })
    },
};
